import { useState, useEffect } from "react";
import api from "@/lib/api";
import { ShieldAlert } from "lucide-react";

// Gate a route/page to Super Admin only. Il backend applica comunque il 403;
// questo evita di mostrare una pagina rotta a un admin non-super che digita l'URL.
export default function SuperAdminOnly({ children }) {
  const [state, setState] = useState("loading"); // loading | ok | denied

  useEffect(() => {
    let alive = true;
    api.get("/auth/me")
      .then((r) => { if (alive) setState(r.data?.is_super_admin ? "ok" : "denied"); })
      .catch(() => { if (alive) setState("denied"); });
    return () => { alive = false; };
  }, []);

  if (state === "loading") {
    return (
      <div className="p-8 flex items-center justify-center" data-testid="superadmin-loading">
        <div className="w-8 h-8 border-2 border-[#20c997] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (state === "denied") {
    return (
      <div className="p-10 flex flex-col items-center justify-center text-center gap-3" data-testid="superadmin-denied">
        <ShieldAlert className="w-10 h-10 text-amber-500" />
        <h2 className="text-lg font-semibold text-[#0f292f]">Accesso riservato</h2>
        <p className="text-sm text-gray-500 max-w-sm">Questa sezione è disponibile solo per il Super Admin.</p>
      </div>
    );
  }
  return children;
}
